<!-- <ion-scroll scrollX="true" class="item" direction="x"> -->
  <div *ngFor="let category of categories; trackBy: trackByFn" (click)="onClickCategory(category)">
    <category-box *ngIf="category.related" [category]="category"></category-box>
  </div>
<!-- </ion-scroll> -->